import { useEffect, useState } from "react";
import Routes from "../routes";

const useGetLocationForDropdown = ({
    onChangeLocation,
    onChangeSubLocation,
    location
}) => {
    const [subLocations, setSubLocations] = useState([]);

    useEffect(() => {
        getSubLocations(location);
    }, [])

    const handleLocationChange = async (e) => {
        onChangeLocation(e.target.value);

        if (onChangeSubLocation) {
            getSubLocations(e.target.value);
        }
    };

    const getSubLocations = async (locationId) => {
        try {
            const response = await fetch(Routes.Location.SubLocations(locationId));
            const data = await response.json();

            if (response.status === 200) {
                const newData = data.map((subLoc) => ({
                    value: subLoc.id,
                    label: subLoc.shortName,
                }))
                setSubLocations(newData);
            }
        } catch (error) {
            console.error("Error fetching subLocations:", error);
        }
    };

    return {
        handleLocationChange,
        subLocations
    }
}

export default useGetLocationForDropdown;